// extracted by css-extract-rspack-plugin
export default {"workspaceId":"pQbyrZTfIPdbCpcd","copy":"lSGYz2i6uMoWnCeh"};